import { InstrumentApi, InstrumentProductTypeEnum } from '@flipster/apis/v2/snapshot';
import { valueof } from '@flipster/utils/typescript';

export const checkListableInstrument = (i: InstrumentApi, productType: valueof<typeof InstrumentProductTypeEnum>) =>
  i.isListed && i.productType === productType;
